import { Box, Stack, StackDivider } from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import { SuspendWithSpinner } from 'components/SuspendWithSpinner';
import React from 'react';
import { graphql, useSafeRelay } from 'utils/graphClient';
import { AuditLogs_Query } from './__generated__/AuditLogs_Query.graphql';
import LogEntry from 'components/AuditLog/components/LogEntry';
import { notEmpty } from 'utils/NotEmptyFilter';

const query = graphql`
  query AuditLogs_Query($id: ID!) {
    node(id: $id) {
      ... on HasAuditLogInterface {
        auditLog {
          nodes {
            id
            ...useLogEntryFragment
          }
        }
      }
    }
  }
`;

interface AuditLogsProps {
  nodeId: string;
}

export const AuditLogs: React.FC<AuditLogsProps> = (props) => (
  <SuspendWithSpinner>
    <SuspendedAuditLogs {...props} />
  </SuspendWithSpinner>
);

const SuspendedAuditLogs: React.FC<AuditLogsProps> = ({ nodeId }) => {
  const { useLazyLoadQuery } = useSafeRelay();
  const { node } = useLazyLoadQuery<AuditLogs_Query>(
    query,
    {
      id: nodeId,
    },
    {
      fetchPolicy: 'store-and-network',
    },
  );

  if (!node?.auditLog?.nodes) {
    return <Box>{t`Could not find any audit log data for this item`}</Box>;
  }

  const nodes = node.auditLog.nodes.filter(notEmpty);

  return (
    <Stack divider={<StackDivider />}>
      {nodes.map((node) => (
        <LogEntry key={node.id} log={node} />
      ))}
    </Stack>
  );
};
